export default __webpack_public_path__ + "static/media/tape.29560349.jpg";